import React from 'react'
import PropTypes from 'prop-types'
import { Button, SelectInput, Modal, Text, Title } from 'components'
import styles from './LocalityModal.module.scss'

const LocalityModal = ({
  closeModal,
  localities,
  opened,
  setSlug,
  sendAction,
}) => {
  const handleClose = () => {
    closeModal()
  }

  return (
    <Modal opened={opened} closeModal={handleClose} className={styles.modal}>
      <section className={styles.localityModal}>
        <header className={styles.header}>
          <div className={styles.info}>
            <Title type="h1" fontSize="xlarge">
              Vamos achar as melhores oportunidades para o seu perfil. Nos
              conte...
            </Title>
            <Text
              fontSize="medium"
              color="lightTextColor"
              className={styles.contactText}
            >
              Busca imóvel em alguma localidade específica?
            </Text>
          </div>
        </header>
        <form autoComplete="false" className={styles.main}>
          <SelectInput
            tabIndex="0"
            setSlug={setSlug}
            availableLocalities={localities}
            aria-autocomplete="list"
            autoComplete="off"
            aria-haspopup="true"
            role="combobox"
          />
        </form>
        <footer className={styles.footer}>
          <Button
            onClick={sendAction}
            type="filled"
            className={styles.button}
            fontSize="medium"
          >
            Encontrar oportunidades
          </Button>
        </footer>
      </section>
    </Modal>
  )
}

LocalityModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  opened: PropTypes.bool.isRequired,
  localities: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    })
  ).isRequired,
  setSlug: PropTypes.func.isRequired,
  sendAction: PropTypes.func.isRequired,
}

export default React.memo(LocalityModal)
